module.exports = __webpack_public_path__ + "static/media/Background-35208.93e086de.mp4";